import * as React from 'react';
import { EControlType, EArrowsSize } from '../../types';
import { DEFAULT_ARROW_ICON_SIZE, DEFAULT_CONTROLS_OFFSET, DEFAULT_LARGE_ARROW_ICON_SIZE } from '../../constants';
import { getControlSettings } from '../../helpers';
import { DefaultCounter } from '../DefaultCounter';
import { DefaultArrows } from '../DefaultArrows';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var FirstPaintRender = function FirstPaintRender(props) {
  var _props$widthSSR = props.widthSSR,
      gap = _props$widthSSR.gap,
      slideWidth = _props$widthSSR.slide,
      leftEar = _props$widthSSR.leftEar,
      rightEar = _props$widthSSR.rightEar,
      slides = props.slides,
      slidesLeftOffsetSSR = props.slidesLeftOffsetSSR,
      currentSlide = props.currentSlide,
      totalSlides = props.totalSlides,
      slidesToShow = props.slidesToShow,
      defaultControls = props.defaultControls,
      arrowsSettings = props.arrowsSettings;
  var counter = getControlSettings(EControlType.COUNTER, defaultControls);
  var arrows = getControlSettings(EControlType.ARROWS, defaultControls);
  var arrowIconSize = arrowsSettings.size === EArrowsSize.NORMAL ? DEFAULT_ARROW_ICON_SIZE : DEFAULT_LARGE_ARROW_ICON_SIZE;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        height: "100%",
        position: 'relative',
        left: "".concat(slidesLeftOffsetSSR),
        display: 'flex'
      },
      children: slides.map(function (slide) {
        return /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            style: {
              width: "calc(".concat(gap, ")"),
              flexShrink: 0
            }
          }), /*#__PURE__*/_jsx("div", {
            style: {
              width: "calc(".concat(slideWidth, ")"),
              flexShrink: 0
            },
            children: slide.node
          })]
        }, slide.key);
      })
    }), counter && /*#__PURE__*/_jsx(DefaultCounter, {
      currentSlide: currentSlide,
      totalSlides: totalSlides,
      rightOffset: "calc(".concat(rightEar, " + ").concat(gap, " + ").concat(DEFAULT_CONTROLS_OFFSET, "px)")
    }), arrows && /*#__PURE__*/_jsx(DefaultArrows, {
      leftAreaWidth: "calc(".concat(leftEar, " + ").concat(gap, " + ").concat(DEFAULT_CONTROLS_OFFSET, "px + ").concat(arrowIconSize, "px)"),
      rightAreaWidth: "calc(".concat(rightEar, " + ").concat(gap, " + ").concat(DEFAULT_CONTROLS_OFFSET, "px + ").concat(arrowIconSize, "px)"),
      showLeft: currentSlide > slidesToShow,
      showRight: currentSlide < totalSlides,
      size: arrowsSettings.size
    })]
  });
};